import { Table } from 'antd';
import '@src/styles/components/customTable.scss';
import { customPaginationProps } from '../CustomPagination';
import PropTypes from 'prop-types';

const CustomTable = ({
  className,
  pagination,
  isScroll = true,
  onPageChange = null,
  ...props
}) => {
  const getCurrentLanguage = () => localStorage.getItem('language')?.slice(1, -1);

  const isEnglishLanguage = () => getCurrentLanguage() === 'en';
  const isEnglish = isEnglishLanguage();

  const handleTableChange = (pagination) => {
    if (onPageChange) {
      onPageChange(pagination);
    }
  };

  const tableLocale = {
    triggerAsc: isEnglish ? 'Sort ascending' : 'Artan düzende sırala',
    triggerDesc: isEnglish ? 'Sort descending' : 'Azalan düzende sırala',
    cancelSort: isEnglish ? 'Clear sorting' : 'Sıralamayı kaldır',
  };

  return (
    <Table
      className={`custom-table ${className || ''}`}
      pagination={pagination !== false ? customPaginationProps(pagination) : false}
      scroll={isScroll ? { x: 992 } : false}
      locale={tableLocale}
      {...props}
      onChange={handleTableChange}
    />
  );
};

CustomTable.propTypes = {
  className: PropTypes.string,
  pagination: PropTypes.any,
  isScroll: PropTypes.bool,
  onPageChange: PropTypes.func,
};

CustomTable.defaultProps = {
  className: '',
};

export default CustomTable;
